import { mode } from "@chakra-ui/theme-tools";

export const globalStylesGray = {
  colors: {
    navy: {
      50: "#f7fafc",
      100: "#edf2f7",
      200: "#e2e8f0",
      300: "#cbd5e0",
      400: "#a0aec0",
      500: "#718096",
      600: "#4a5568",
      700: "#2d3748",
      800: "#1a202c",
      900: "#12151f",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("gray.50", "gray.800")(props),
        fontFamily: "Helvetica, sans-serif",
      },
      html: {
        fontFamily: "Helvetica, sans-serif",
      },
      "::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: mode("gray.100", "gray.900")(props),
      },
      "::-webkit-scrollbar-thumb": {
        background: mode("gray.400", "gray.700")(props),
        borderRadius: "8px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: mode("gray.500", "gray.600")(props),
      },
      ".rdtPicker": {
        bg: mode("white", "gray.700")(props),
        color: mode("gray.800", "gray.50")(props),
        border: `1px solid ${mode("gray.300", "gray.600")(props)}`,
      },
    }),
  },
};
